import React from 'react';
import { Hidden } from '@material-ui/core';
import ResetDashboard from '../../Filters/ResetDashboard/ResetDashboard';

const FlyoutResetDashboard = function FlyoutResetDashboard(): React.ReactElement {
  return (
    <Hidden mdUp>
      <ResetDashboard />
    </Hidden>
  );
};

export default FlyoutResetDashboard;
